import React from "react";
import { usePanelTheme } from "../context/themeContext";

export default function SectionHeading({ title, subtitle }) {
  const { theme, currentTheme } = usePanelTheme();

  return (
    <div>
      <h2
        className={`text-2xl font-bold tracking-tight ${
          theme === "dark" ? "text-slate-100" : "text-slate-900"
        }`}
      >
        {title}
      </h2>
      {subtitle ? (
        <p className={`mt-1 text-sm ${currentTheme.muted}`}>{subtitle}</p>
      ) : null}
    </div>
  );
}